import React from "react";
import {
  List,
  Datagrid,
  TextField,
  TextInput,
  Edit,
  EditButton,
  Delete,
  Filter,
  SelectInput,
  ReferenceInput,
  TabbedForm,
  FormTab,
  DateField,
  ReferenceField,
  BooleanInput,
  FunctionField,
  translate,
  BooleanField
} from "admin-on-rest/lib/mui";

import { Actions } from "../custom/action_no_save";
import StarRatingField from "./custom/StarRatingField";
import Gallery from "./custom/gallery_complaint";
import NameForm from "../custom/answerButton";
import CustomImageField from "./custom/imageSize";
import SubGenreInput from "./custom/SubGenreInput";
import { DependentInput } from "aor-dependent-input";
import MyHelloButton from "../custom/MyHelloButton";
import Toggle from "../custom/Toggle/CheckButton";

function tranlate(type) {
  var res = "resources." + type + ".name";

  return translate(res);
}

export const ComplaintFilter = props => (
  <Filter {...props}>
    <TextInput
      label="resources.search_params.name"
      source="title"
      alwaysOn="alwaysOn"
    />
    <ReferenceInput
      label="resources.branches.name"
      source="BranchID"
      reference="branches"
      allowEmpty="allowEmpty"
      alwaysOn="alwaysOn"
      perPage={1000}
    >
      <SelectInput
        optionText={choice => `${choice.tmima + " " + choice.address}`}
      />
    </ReferenceInput>

    <ReferenceInput
      label="resources.users.name"
      source="userID._id"
      filter={{
        withComments: true
      }}
      reference="users"
      allowEmpty="allowEmpty"
      alwaysOn="alwaysOn"
      perPage={1000}
    >
      <SelectInput optionText={choice => `${choice.username}`} />
    </ReferenceInput>

    <DependentInput dependsOn="CompanyID">
      <SubGenreInput />
    </DependentInput>

    <SelectInput
      allowEmpty="allowEmpty"
      label="resources.category.name"
      source="category"
      choices={[
        {
          id: "Γενικό σχόλιο",
          name: "Γενικό σχόλιο"
        },
        {
          id: "Προϊόν",
          name: "Προϊόν"
        },
        {
          id: "Όχημα",
          name: "Όχημα"
        },
        {
          id: "Σχόλιο υπαλλήλου",
          name: "Σχόλιο υπαλλήλου"
        }
      ]}
      alwaysOn="alwaysOn"
    />

    <SelectInput
      allowEmpty="allowEmpty"
      label="resources.type_of_commnet.name"
      source="type_complaints"
      choices={[
        {
          id: "positive",
          name: "resources.positive.name"
        },
        {
          id: "negative",
          name: "resources.negative.name"
        }
      ]}
      alwaysOn="alwaysOn"
    />
  </Filter>
);

export const ComplaintsList = props => (
  <List
    {...props}
    actions={<Actions />}
    filters={<ComplaintFilter />}
    title="resources.management_comments.name"
  >
    <Datagrid {...props}>
      <Toggle />
      <CustomImageField
        width={200}
        height={125}
        source="gallery[0]"
        label="εικονα"
      />
      <DateField
        label="resources.date.name"
        source="date"
        showTime="showTime"
      />
      <TextField label="resources.title.name" source="title" />
      <TextField label="resources.category.name" source="category" />
      <TextField label="resources.description.name" source="description" />
      <BooleanField label="resources.read.name" source="read" />
      <MyHelloButton record={props} />

      <ReferenceField
        linkType="none"
        label="resources.department.name"
        source="BranchID"
        reference="branches"
      >
        <TextField source="tmima" />
      </ReferenceField>

      <DependentInput dependsOn="CompanyID">
        <TextField label="resources.branches.name" />
        <SubGenreInput />
      </DependentInput>

      <EditButton />
    </Datagrid>
  </List>
);

const PostTitle = ({ record }) => {
  return <span>{record ? `${"Χρήστης: " + record.userID.username}` : ""}</span>;
};

export const EditComplaint = props => (
  <Edit title={<PostTitle />} {...props}>
    <TabbedForm>
      <FormTab label="general">
        <TextField label="resources.description.name" source="title" />
        <TextField label="resources.comments.name" source="description" />
        <DateField
          label="resources.date.name"
          source="date"
          showTime="showTime"
        />
        <StarRatingField />
        <TextField source="category" />

        <ReferenceField
          label="resources.companies.name"
          source="CompanyID"
          reference="companies"
        >
          <TextField source="name" />
        </ReferenceField>

        <DependentInput dependsOn="CompanyID">
          <TextField label="resources.branches.name" />
          <SubGenreInput />
        </DependentInput>

        <BooleanInput label="resources.read.name" source="read" />

        <NameForm record={props} />
      </FormTab>
      <FormTab label="photos">
        <Gallery source="gallery" />
      </FormTab>
    </TabbedForm>
  </Edit>
);

const DeleteTitle = ({ record }) => {
  return <span>{record ? `Διαγραφή του ${record.title}` : ""}</span>;
};

export const DeleteComplaint = props => (
  <Delete title={<DeleteTitle />} {...props} />
);



// WEBPACK FOOTER //
// ./src/pages/complaints.js